import { PublicFranchiseBranding } from "../../services/Franchises/Franchises.type";
import {
  SET_FRANCHISE_BRANDING,
  SET_FRANCHISE_ERROR,
  SET_FRANCHISE_LOADING,
  SET_FRANCHISE_SLUG,
} from "./actionTypes";

export const setFranchiseSlug = (slug: string | null) => ({
  type: SET_FRANCHISE_SLUG,
  payload: slug,
});

export const setFranchiseBranding = (branding: PublicFranchiseBranding | null) => ({
  type: SET_FRANCHISE_BRANDING,
  payload: branding,
});

export const setFranchiseLoading = (loading: boolean) => ({
  type: SET_FRANCHISE_LOADING,
  payload: loading,
});

export const setFranchiseError = (error: string | null) => ({
  type: SET_FRANCHISE_ERROR,
  payload: error,
});
